
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ranking/[franchiseSlug]/sector",
      function () {
        return require("private-next-pages/ranking/[franchiseSlug]/sector/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ranking/[franchiseSlug]/sector"])
      });
    }
  